import React from "react";
import { TravelWalletOffer } from "redmond";
import { filterOutSpendAndGetOffers } from "halifax";
import {
  getExperimentVariantJSON,
  LUX_Q2_VR_OFFER_CTAS,
  LuxQ2VROfferCtasConfig,
  useExperiments,
} from "../context/experiments";

export const useQ2VROffer = (
  offers: TravelWalletOffer[],
): TravelWalletOffer | undefined => {
  const expState = useExperiments();

  const luxQ2VROfferCtasConfig = getExperimentVariantJSON(
    expState.experiments,
    LUX_Q2_VR_OFFER_CTAS,
  ) as LuxQ2VROfferCtasConfig | null;

  return React.useMemo(() => {
    const offerIds = luxQ2VROfferCtasConfig?.offerIds;
    if (!offerIds || offerIds.length === 0) {
      return undefined;
    }
    const filteredOffers = filterOutSpendAndGetOffers(offers);
    return filteredOffers.find((offer) =>
      offer.descriptions.some((desc) => offerIds.includes(desc)),
    );
  }, [offers, luxQ2VROfferCtasConfig]);
};
